<template>
    <v-app-bar v-if="!$route.meta.hideNavigation" app color="oug" dark dense>
      <v-toolbar-title >
         {{ new Date().getFullYear() }} - {{Title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
</template>

<script>
export default {
    name: 'Header',
    components: {
            
    },
  props: {
    Title: {
      Type: String,
      Required: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
}
        
</script>

<style lang="scss" scoped>

</style>